export function countryFilter(input: string): string {

    if(input === null){
        return null;
    }

    const i18n: any = this.context.i18n.global;

    return i18n.t(`country.${input.toLowerCase()}`);
}